import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteEstagioAplicacaoCadastro } from '../service';
import {
  DELETE_ESTAGIO_APLICACAO_CADASTRO,
  DELETE_ESTAGIO_APLICACAO_CADASTRO_PENDING,
  DELETE_ESTAGIO_APLICACAO_CADASTRO_SUCCESS,
  DELETE_ESTAGIO_APLICACAO_CADASTRO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteEstagioAplicacaoCadastro(action) {
  yield put({ type: DELETE_ESTAGIO_APLICACAO_CADASTRO_PENDING, id: action.id });

  trackingEventCX('action', MODULE_ACTIONS_ENUM.ESTAGIO_APLICACAO_EXCLUIR);

  try {
    const a = yield call(deleteEstagioAplicacaoCadastro, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_ESTAGIO_APLICACAO_CADASTRO_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0);
    });
  } catch (error) {
    yield put({ type: DELETE_ESTAGIO_APLICACAO_CADASTRO_FAILURE });

    AlertError('Falha ao excluir o registro! Tente novamente...');
  }
}

export default function* watchDeleteEstagioAplicacaoCadastro() {
  yield takeLatest(DELETE_ESTAGIO_APLICACAO_CADASTRO, sagaDeleteEstagioAplicacaoCadastro);
}
